import React from 'react'
import { Button } from "react-bootstrap";

export const Data = [
    { id: 1, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 2, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 3, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 4, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 5, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 6, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 7, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 8, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 9, exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 10,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 11,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 12,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 13,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 14,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 15,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 16,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 17,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 18,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 19,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 20,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 21,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 22,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 23,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 24,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 25,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 26,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 27,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 28,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 29,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 30,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 31,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 32,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 33,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 34,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 35,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 36,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 37,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 38,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 39,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
    { id: 40,  exam: 'NEET', class: 'XI', section: 'A', branches: 'All', conducted: '29-05-2019, 10:00 AM', result: '50/60 88%', status: 'Completed' },
 ];

export const Columns = [
    {
        dataField: "exam",
        text: "Exam Name",
        sort: true,
        formatter: actionsFormatter2
    },
    {
        dataField: "class",
        text: "Class",
        sort: true
    },
    {
        dataField: "section",
        text: "Section",
        sort: true
    },
    {
        dataField: "branches",
        text: "Branches",
        sort: true,
        formatter: actionsFormatter3
    },
    {
        dataField: "conducted",
        text: "Conducted On",
        sort: true
    },

    {
        dataField: "result",
        text: "Result",
        sort: true
    },
    
    {
        dataField: "status",
        text: "Status",
        sort: true
    },
    {
        dataField: "actions",
        text: "Actions",
        sort: true,
        formatter: actionsFormatter,
        headerAttrs: { width: 50 },
        headerAlign: 'center',
        align: 'center',
        attrs: { width: 50, className: "EditRow" }
    }
];

export const defaultSorted = [
    {
        dataField: "title",
        order: "desc"
    }
];

function actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
        <div className="actions-buttons d-flex justify-content-center align-items-top">
            <Button variant="link" className="text-theme"><i className="far fa-eye"/></Button>
            <Button variant="link" className="text-theme"><i className="far fa-edit"/></Button>
            <Button variant="link" className="text-danger"><i className="far fa-trash-alt"/></Button>
        </div>
    );
}

function actionsFormatter2(cell, row, rowIndex, formatExtraData) {
    return (
        <div className="text-link">
            <a className="text-dark" href="/questions/manage-question-paper/question-paper-result">{row['exam']}</a>
        </div>
    );
}

function actionsFormatter3(cell, row, rowIndex, formatExtraData) {
    return (
        <div className="text-link">
            <a className="text-dark" href="/questions/manage-question-paper/question-paper-result">{row['branches']}</a>
        </div>
    );
}

